module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/core-js/modules/_perform.js
// module id = X7pO
// module chunks = 1